function getPortalUrl() {
    let octopusUrl = "#{PORTAL_API_URL}";
    //  return getUrlTransformed(octopusUrl, "{PORTAL_API_URL}", "http://localhost:51384") + "/api";

    // development API
    // return getUrlTransformed(octopusUrl, "{PORTAL_API_URL}", "https://parkingappapidev.easytrip.ie") + "/api"; 

    // Staging
    // return getUrlTransformed(octopusUrl, "{PORTAL_API_URL}", "https://prebookingapistg.easytrip.ie") + "/api"; // + "/1.1.350/api";
    return getUrlTransformed(octopusUrl, "{PORTAL_API_URL}", "https://parkingappapistg.easytrip.ninja") + "/api"; // + "/1.1.350/api";
    // https://prebookingapistg.easytrip.ie/api/Offerings?locationId=4804847b-78b9-49bb-aebb-551efd8e4fab&startDate=2023-03-10/Get

    // PROD
    // return getUrlTransformed(octopusUrl, "{PORTAL_API_URL}", "https://parkingapp.api.easytrip.ie") + "/api"; // + "/1.1.350/api"; 
    // return getUrlTransformed(octopusUrl, "{PORTAL_API_URL}", "https://parkingapp.api.easytrip.ie") + "/api"; // + "/1.1.350/api"; 
}




function getRealexPaymentUrl(){
    let realexUrl="#{PORTAL_REALEX_URL}";
    return getUrlTransformed(realexUrl, "{PORTAL_REALEX_URL}", "https://pay.sandbox.realexpayments.com/pay");
}
function getUrlTransformed(url, stringTransform, defaultUrl) {
    return !url.includes(stringTransform) ? url : defaultUrl;
}

let apis = {
    basePortal: getPortalUrl(),
    user: getPortalUrl() + "/user",
    prebooking: getPortalUrl() + "/prebooking",
    pricing:getPortalUrl() +"/pricing",
    realexUrl:getRealexPaymentUrl(),
    payment: getPortalUrl() + "/payment",
    vehicle:getPortalUrl()+"/vehicle"
};

export default apis;



// WEBPACK FOOTER //
// ./src/config/api.js